@if (isFilterToolbarVisible()) {
	<div class="panel" [ngClass]="{ 'standalone-style': !standaloneStyle() }">
		<div class="group form-inline">
			@if (showSearch()) {
				<div class="input-container">
					<label
						for="searchByName"
						class="form-label"
						translate="management.process.interfaces.filter.search.label"
					></label>
					<div class="filter-container">
						<input
							id="searchByName"
							type="search"
							class="fullsize search"
							[(ngModel)]="searchTermValue"
							placeholder="{{ placeholderText() | translate }}"
							(stagesDebouncedChange)="onSearchTermChange()"
							delay="1000"
						/>
					</div>
				</div>
			}
			@if (dropdownContent.length > 0) {
				<div class="input-container">
					<label
						for="typeFilter"
						class="form-label"
						translate="management.process.interfaces.filter.type.label"
					></label>
					<div class="filter-container">
						<select
							name="dropdown"
							id="typeFilter"
							class="fullsize"
							[(ngModel)]="dropdownValue"
							(change)="onFilterTypeChange()"
						>
							@for (option of dropdownContent; track option) {
								<option [ngValue]="option.ident" [translate]="option.translate"></option>
							}
						</select>
					</div>
				</div>
			}
		</div>
	</div>
}
